export const INITIAL_RENDER = 'INITIAL_RENDER';
export const SET_COOKIE_RESPONSE = 'SET_COOKIE_RESPONSE';
export const FINISH_SERVER_SIDE_RENDERING = 'FINISH_SERVER_SIDE_RENDERING';
export const LOGOUT = 'LOGOUT';
export const INVITE_RENTER_TO_APPLY_CLICK = 'INVITE_RENTER_TO_APPLY_CLICK';
export const INVITE_TO_APPLY_MODAL_REQUEST_CLOSE = 'INVITE_TO_APPLY_MODAL_REQUEST_CLOSE';
export const REQUEST_APPLICATION_MANAGER_TO_IDV = 'REQUEST_APPLICATION_MANAGER_TO_IDV';
export const CANCEL_APPLICATION_MANAGER_IDV_REQUEST = 'CANCEL_APPLICATION_MANAGER_IDV_REQUEST';
export const NAVIGATED_TO_ZTSS = 'NAVIGATED_TO_ZTSS';
export const SET_IS_LAYOUT_HORIZONTAL = 'SET_IS_LAYOUT_HORIZONTAL';
